/* eslint-disable no-undef */
(function (window) {
    "use strict";
    function defineTestService() {
        let testService = {};
        testService.ping = function (){
            return axios.get("/api/TestService/Ping");
        };
        return testService;
    }
    //define globally if it doesn't already exist
    if (typeof (testService) === "undefined") {
        window.testService = defineTestService();
    } else {
        console.log("testService already defined.");
    }
})(window);